module.exports = __webpack_public_path__ + "static/media/English - Teaching - Road to Enlightenment (load_2) - translated by JL.9b195eec.txt";